/* eslint-disable max-len */
const landing = {
	TOOLS: 'Tools',
	BDT_ROUTING_NUM: 'BDT Routing Number',
	TRANSFER_TRACKING: 'Transfer Tracking',
	IFSC: 'IFSC',
	BDT: 'BDT',
	TRACK_TRANSFER_FOR_BUSINESS_INDIVIDUALS: 'TRACK TRANSFER FOR BUSINESS & INDIVIDUALS',
	TRACK_YOUR_TRANSFER: 'Track Your Transfer',
	TRACKING_INSTRUCTIONS:
		'Stay updated on your transfer progress with ease. Simply enter your order number in the field below to view the latest status of your transaction.',
	SEARCH: 'Search',
	FREQUENTLY_ASKED_QUESTIONS: 'Frequently Asked Questions',
	FAQ: 'FAQ',
	HAVING_ISSUES_WITH_RECEVING_FUNDS: 'Having issues with receiving funds?',
	GO_TO_SUPPORT: 'Go to Support',
	TRACK_TRANSFER: 'Track Transfer',
	START_TRACKING: 'Start Tracking',
	ENTER_ORDER_NUMBER_TO_TRACK_TRANSFER_STATUS: 'Enter order number to track transfer status',
	UNABLE_TO_GET_TRACKING_DETAILS: 'Unable to get tracking details',
	PLEASE_ENSURE_THE_ORDER_NUMBER_IS_CORRECT: 'Please ensure the order number is correct',
	LINK_EXPIRED: 'Link Expired',
	THE_LINK_HAS_EXPIRED_AND_NO_LONGER_AVAILABLE_FOR_TRACKING: 'The link has expired and no longer available for tracking',
	ORDER_IS_NOT_READY_FOR_TRACKING: 'Order is not ready for tracking',
	PENDING_ACTION_BY_SENDER: 'Pending action by the sender',
	ORDER_CANCELLED_OR_EXPIRED: 'Order Cancelled/Expired',
	PLEASE_REACH_OUT_TO_THE_SENDER_FOR_DETAILS: 'Please reach out to the sender for details',
	ORDER_HAS_EXPIRED: 'Order has expired',
	PROCESSING: 'Processing...',
	ORDER_IS_BEING_REVIEWED: 'Order is being reviewed',
	UNABLE_TO_PROCESS_ORDER: 'Unable to process order',
	FUNDS_ARE_ON_THEIR_WAY: 'Funds are on their way...',
	ESTIMATED_ARRIVAL: 'Estimated Arrival: ',
	TRANSFER_COMPLETE: 'Transfer complete!',
	YOU_SHOULD_HAVE_RECEIVED_THE_FUNDS_BY_NOW: 'You should have received the funds by now',
	ORDER_HAS_BEEN_CANCELLED: 'Order has been cancelled',
	TRANSACTION_DETAILS: 'Transaction Details',
	ORDER_NUMBER: 'Order Number',
	DATE_CREATED: 'Date Created',
	PAYOUT_METHOD: 'Payout Method',
	RECIPIENT_GETS: 'Recipient gets',
	RECIPIENT_DETAILS: 'Recipient Details',
	COUNTRY: 'Country',
	CURRENCY: 'Currency',
	NAME: 'Name',
	NATIVE_NAME: 'Native Name',
	BANK_ACCOUNT_NUMBER: 'Bank Account Number',
	BANK_NAME: 'Bank Name',
	DIGITAL_WALLET_ID: 'Digital Wallet ID',
	DIGITAL_WALLET_PROVIDER: 'Digital Wallet Provider',
	CASH_PICKUP_INFORMATION: 'Cash Pickup Information',
	PICKUP_AGENT: 'Pickup Agent',
	LOCATION: 'Location',
	AT_ANY_BRANCHES: 'At any branches,',
	MORE_INFO: 'more info',
	WHEN_WILL_MY_MONEY_ARRIVE: 'When will my money arrive?',
	MONEY_NOT_IN_ACCOUNT_YET: 'Money’s not in your account yet?',
	STANDARD_PROCESSING_TIME: 'Standard Processing Time',
	TRANSFER_DURATION: 'Transfers typically reach the recipient within 1-2 business days after being marked as "In-Transit".',
	TRANSFER_EXCEPTION_DURATION: 'In certain situations, transfers may take up to 4 business days. Factors contributing to delays include:',
	RECIPIENT_BANK_VALIDATION: 'Recipient’s Bank Validation:',
	COMPLIANCE_CHECKS: 'Compliance Checks:',
	BANK_HOLIDAYS_AND_WEEKENDS: 'Bank Holidays and Weekends:',
	FURTHER_ENQUIRIES_PREFIX: 'If you have any further questions, please visit our',
	FURTHER_ENQUIRIES_LINK: 'support article',
	FURTHER_ENQUIRIES_SUFFIX: 'for more details.',
	FUND_NOT_YET_RECEIVED_REASON:
		'In some cases, the tracker may indicate that the transfer is complete. However, the funds may still be held by the recipient’s bank due to some reasons:',
	ADDITIONAL_SECURITY_CHECKS: 'additional security checks:',
	LIMITED_PROCESSING_SCHEDULES: 'limited processing schedules:',
	CLOSURES_DUE_TO_PUBLIC_HOLIDAYS: 'closures due to public holidays:',
	FUND_NOT_YET_RECEIVED_ASSISTANCE:
		'If the transfer has not been received after three business days, it is recommended to reach out to your bank or sender for further assistance.',
	ENTER_ORDER_NUMBER: 'Enter Order Number',
	ENTER_ORDER_NUMBER_PLACEHOLDER: 'Please enter valid Order Number',
	ORDER_NUMBER_VALIDATION: 'Order Number must consist of only letters and numbers',
	OKAY_GOT_IT: 'Okay, Got It',
	PROCESSING_ORDER: 'Processing Order',
	ORDER_HAS_BEEN_REVIEWED_AND_PROCESSED: 'Order has been reviewed and processed',
	ORDER_COULD_NOT_BE_PROCESSED: 'Order could not be processed',
	FUNDS_ARE_IN_TRANSIT: 'Funds are on their way',
	TRANSFER_HAS_FAILED: 'Transfer has failed',
	FUNDS_SHOULD_HAVE_ARRIVED_AT_YOUR_BANK: 'Funds should have arrived at your bank',
	TRANSFER_HAS_CANCELLED: 'Transfer has cancelled',
	ORDER_HAS_BEEN_CREATED: 'Order has been created',
	DEPOSIT_HAS_BEEN_MADE: 'Deposit has been made',
	WE_ARE_REVIEWING_AND_PROCESSING_THE_ORDER: 'We are reviewing and processing the order',
	PLEASE_REACH_OUT_TO_THE_SENDER_FOR_MORE_DETAILS: 'Please reach out to the sender for more details',
	TRANSFER_IS_COMPLETED: 'Transfer is completed',
	PLEASE_COLLECT_YOUR_FUNDS_AT_THE_DESIGNATED_LOCATION: 'Please collect your funds at the designated location',
	LAST_REFRESHED_STATUS: 'Status last refreshed at:'
};

export default landing;
